import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import ProductInfoForLabels from '@square/dashboard-items-data/models/squareup/inventory/v3/product-info-for-labels';
export const PrepareLabelsForGenerationErrorTypes = new Enum(['SKU_TOO_LONG', 'SKU_NOT_ASCII', 'SKU_BARCODE_TOO_WIDE', 'GTIN_NOT_ASCII', 'GTIN_BARCODE_TOO_WIDE']);
export const PrepareLabelsForGenerationError = ProtoBaseModel.extend({
  type: attr(PrepareLabelsForGenerationErrorTypes),
  product: attr(ProductInfoForLabels)
});
export default ProtoBaseModel.extend({
  labelGenerationToken: attr(String),
  errors: repeated(PrepareLabelsForGenerationError)
});